import { ReactNode } from 'react';
import { TDocType } from 'components/Registration/IntroducerOnboarding/RegistrationForm/registrationForm.types';
import styles from './FileUpload.module.css';

type TDocumentUploadCopy = {
  label: ReactNode;
  instruction: ReactNode;
};

export const DOCUMENT_UPLOAD_UK: Record<TDocType, TDocumentUploadCopy> = {
  proof_of_address: {
    label: 'Proof of business address',
    instruction:
      'Upload a recent bank statement, utility bill, or a letter from HMRC or Companies House, dated within the last 3 months and in PDF format.',
  },
  bank_statement: {
    label: 'Bank statements',
    instruction: (
      <>
        Upload a recent bank statement dated within the last 3 months and in PDF
        format.
        <ul className={styles.list}>
          <li>
            This should be for the account(s) where the majority of the business
            revenue is generated.
          </li>
          <li>
            Please also ensure it displays the business name, sort code, account
            number, and balance, and relate to the account where most business
            revenue is received.
          </li>
        </ul>
      </>
    ),
  },
  certified_id: {
    label: 'Certified ID',
    instruction:
      'Upload a clear copy of your valid passport or driving licence in PDF, JPG, JPEG, or PNG format.',
  },
};
